import PropTypes from "prop-types";
// material
import { Box } from "@mui/material";

import { useNavigate } from "react-router-dom";

// ----------------------------------------------------------------------

Logo.propTypes = {
  sx: PropTypes.object,
};

export default function Logo({ sx }) {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate("/");
  };

  return (
    <Box
      component="img"
      src="/assets/contactie_logo.png"
      onClick={handleLogoClick}
      sx={{
        width: "auto",
        height: 40,
        ...sx,
        marginBottom: "20px",
        marginTop: "20px",
        cursor: "pointer",
      }}
    />
  );
}
